var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoHelvetiaWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 240,
    viewBox: "0 0 212.598 49.849",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M191.187 39.38l.719-.063 3.875 9.125-.875-.156-3.719-8.906z",
    fill: "#e2001a",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M186.368 11.415l-.152-.359 9.653-2.205.108.26-9.608 2.303z",
    fill: "#6f4c84",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M182.218 2.398l.094-.251.215-.036 3.764 9.075-.049.004-.022.036-4.002-8.829z",
    fill: "#885fa0",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#885fa0",
    overflow: "visible",
    d: "M181.662 18.634l2.217.44-7.272 17.979-2.217-.441z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a2ac",
    overflow: "visible",
    d: "M173.352 35.394h18.211v5.828h-18.211z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#543864",
    overflow: "visible",
    d: "M170.705 35.738l13.876-2.952 1.12 3.446-13.876 2.951z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a2ac",
    overflow: "visible",
    d: "M168.656 33.924l7.532.249-1.197 2.965-7.531-.248z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M195.456 48.492l-30.616-5.499 3.271-7.666 23.384 4.004 3.961 9.161z",
    fill: "#00a2ac"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M127.437 10.844c-2.315 0-4.219 1.902-4.219 4.219 0 2.315 1.904 4.219 4.219 4.219 2.319 0 4.219-1.904 4.219-4.219 0-2.316-1.9-4.219-4.219-4.219zM-.001 11.875V43H7.53V32.125c0-2.481.96-5.063 3.938-5.063 3.019 0 3.375 2.581 3.375 5.063V43h7.531V30c0-5.378-2.596-8.938-7.969-8.938-2.938 0-5.074 1.091-6.813 3.406h-.063V11.874H-.002zm50.094 0V43h7.531V11.875h-7.531zm60.375 3.531v6.375h-2.438v6.188h2.438V43h7.531V27.969h4.25v-6.188h-4.25v-6.375h-7.531zM36.28 21.062c-6.91 0-11.75 4.27-11.75 11.344 0 7.321 5.25 11.281 12.281 11.281 4.837 0 9.58-2.278 10.781-7.281h-7.219c-.828 1.405-1.981 1.969-3.594 1.969-3.102 0-4.719-1.662-4.719-4.719h15.844v-.813c0-7.238-4.265-11.781-11.625-11.781zm58.969 0c-6.905 0-11.719 4.27-11.719 11.344 0 7.321 5.251 11.281 12.281 11.281 4.836 0 9.584-2.278 10.781-7.281h-7.25c-.826 1.405-1.981 1.969-3.594 1.969-3.103 0-4.719-1.662-4.719-4.719h15.844v-.813c0-7.238-4.264-11.781-11.625-11.781zm48.781 0c-6.289 0-10.625 5.23-10.625 11.313 0 6.08 4.4 11.312 10.688 11.313 2.482 0 5.081-.951 6.406-3.063h.094V43h7.531V21.781h-7.531v2.063c-1.572-1.863-4.126-2.781-6.563-2.781zm-85.656.719L69.499 43h4.781l11.094-21.219h-8.438l-5.063 10.875-5.063-10.875h-8.438zm65.313 0V43h7.5V21.781h-7.5zm-87.031 4.156c2.028 0 3.876 1.349 4.25 3.375h-8.719c.458-2.191 2.278-3.375 4.469-3.375zm58.969 0c2.026 0 3.91 1.349 4.281 3.375h-8.75c.454-2.191 2.276-3.375 4.469-3.375zM146 27.593c3.059 0 4.844 2.207 4.844 4.813 0 2.689-1.785 4.75-4.844 4.75-3.061 0-4.844-2.061-4.844-4.75 0-2.605 1.783-4.812 4.844-4.813z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#885fa0",
    overflow: "visible",
    d: "M185.344 10.62l2.825 1.903-5.38 7.983-2.824-1.903z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M185.094 18.656l-2.313.563-7.5 17.344 9.656-2.5L188.031 27l-2.938-8.344z",
    fill: "#543864"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M182.305 2.125L192.041 0l3.916 8.984-9.705 2.234-3.947-9.092z",
    fill: "#6f4c84"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M168.111 35.327l14.194-33.201 3.949 9.091-10.97 25.339-7.173-1.229z",
    fill: "#885fa0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M184.937 34.062l-9.656 2.5 16.219 2.781 1.094-.281c-.055-.139-.807-1.854-1.75-4l-5.906-1z",
    fill: "#006c73"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M182.789 19.209l3.465-7.993 16.76 38.631-7.558-1.356-12.668-29.282z",
    fill: "#e2001a"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M186.253 11.217l9.705-2.234 16.64 38.166-9.585 2.699-16.76-38.631z",
    fill: "#b70618"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHelvetiaWhite);
export default __webpack_public_path__ + "static/media/logo_helvetia_white.0a359cd2f97fe52c880e83cb588f9cb4.svg";
export { ForwardRef as ReactComponent };